<template>
  <section>
    <div class="box">
      <div class="box-conatiner">
        <div>
          <span class="titulo">Total no período</span>
          <input v-money="money"
                 :value="valorTotal"
                 disabled
                 class="col-8 valor">
        </div>
        <div>
          <span class="titulo">Total selecionadas</span>
          <input v-money="money"
                 :value="valorSelecionados"
                 disabled
                 class="col-8 valor">
        </div>
        <div>
          <b-button variant="primary pt-2 pb-2"
                    :disabled="botaoStatus"
                    @click="receberPagamentos">
            Receber todas as selecionadas
          </b-button>
        </div>
      </div>
    </div>
    <ModalRecebimentoPg :prop-open-modal="modalRecebimento"
                        :prop-lista-pagamento="propListaPagamento"
                        @atualizarTabela="atualizarTabela" />
  </section>
</template>

<script>
  //Importes
  import { VMoney } from 'v-money'

  // Components
  import ModalRecebimentoPg from './ModalRecebimentoPg.vue'


  export default ({
    name: 'ReceberPagamentosFaturados',
    components: {
      ModalRecebimentoPg
    },
    directives: {
      money: VMoney
    },
    props: {
      // Verifica se o componente está sendo chamado em mensalista
      propMensalista: {type: Array, default: null},
      propListaPagamento: {type: Array, default: Array}
    },
    data () {
      return {
        valorTotal: 0,
        valorSelecionados: 0,
        modalRecebimento: false,
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
      }
    },
    computed: {
      botaoStatus () {
        return this.propListaPagamento.length ? false : true
      }
    },
    watch: {
      propMensalista () {
        if (this.propMensalista) {
          this.valorTotal = 0
          this.propMensalista.forEach(pedido => {
            this.valorTotal = this.valorTotal + pedido.ordemServico.valor_total
          })
        }
      },
      propListaPagamento (lista) {
        if (this.propListaPagamento) {
          this.valorSelecionados = 0
          lista.forEach(pedido => {
            this.valorSelecionados = this.valorSelecionados + pedido.ordemServico.valor_total
          })
        }
      }
    },
    methods: {
      async receberPagamentos () {
        this.modalRecebimento = !this.modalRecebimento
      },
      async atualizarTabela () {
        this.$emit('atulizarTabela')
      }
    }
  })
</script>

<style lang="scss" scoped>
.box {
  width: 1167px;
  position: fixed;
  top: 70%;
  padding: 20px 20px;
  border: solid 1px black;
  background-color: white;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
    .box-conatiner {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 30px;
        div {
        display: flex;
        flex-direction: column;
        }
    }
}
.titulo {
  font-size: 22px;
  font-weight: bold;
}
.valor {
  font-size: 18px;
  text-align: left;
  margin: 0;
  padding: 0;
}
</style>
